import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-ce068f0a.js';
import './chunk-1f2cfc27.js';
import './chunk-4139443a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-f28f2092.js';
import { A as Autocomplete } from './chunk-43a9d081.js';
export { A as BAutocomplete } from './chunk-43a9d081.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;
